export enum CREATE_VALUE_NAMES {
    ClientIp = "client_ip",
    Company = "company",
    ExpiresAt = "expires_at",
    HardwareKey = "hardware_key",
    ImeiRestricted = "imei_restricted",
    Name = "name"
}
